<template>
    <div v-if="!user.link_expiry">
        <div>
            <h1 class="has-text-white title">Welcome Back! {{user.customername}}</h1>
            <p class="has-text-white subtitle">Please confirm wheater the following details are correct and click the button to proceed</p>
                <p>Customer Name : {{user.customername}}</p>
                <p>Customer Email : {{user.email}}</p>
                <p>Customer Mobile : {{user.mobile}}</p>
        </div>
        <br>
        <button @click="handleConfirm" :class="classNames">Confirm and Locate Me</button>
    </div>
    <div v-else>
        <div v-if="!linkRenewSent">
            <h1  class="is-size-1">This link has expired</h1>
            <button @click="handleRenew" :class="classNames">Renew Link</button>
        </div>
        <h1 v-else class="is-size-4">A new link has been sent your registered mobile number</h1>
    </div>
</template>

<script>
import API from "../API";
import Raven from "raven-js";

export default {
  name: "WebViewRegister",
  data() {
    return {
      user: {},
      linkRenewSent: false,
      classNames: {
        button: true,
        "is-loading": false
      }
    };
  },
  created() {
    let uid = this.$route.params.uid;
    API.get(`getwebviewcustomers?unique_code=${uid}`).then(
      res => (this.user = res.data.data.webviewdetails)
    );
  },
  methods: {
    handleRenew() {
      API.post("renewwebviewlink", this.user)
        .then(res => {
          if (res.status === 200) {
            this.linkRenewSent = true;
          }
        })
        .catch(err => console.log(err));
    },
    getGeoLocation() {
      if ("geolocation" in navigator) {
        return new Promise(function(resolve, reject) {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });
      } else {
        this.$router.push({
          name: "Error",
          params: {
            title: "Browser Unsupported",
            message:
              "We're sorry but the browser you are using does not support location services",
            errorText: err.message
          }
        });
      }
    },
    handleConfirm() {
      this.classNames["is-loading"] = true;
      this.getGeoLocation()
        .then(position => {
          this.user["lat"] = String(position.coords.latitude);
          this.user["lng"] = String(position.coords.longitude);
          this.user["ref_url"] = this.user.register_location;
          API.post("webviewregisteration", this.user)
            .then(res => {
              if (res.data.data.errormsg) {
                this.$router.push({
                  name: "Error",
                  params: {
                    title: "Error",
                    message: res.data.data.errormsg
                  }
                });
              } else {
                res.data.data.weather_details["webview_uid"] = this.user.id;
                let offerData = JSON.stringify(res.data.data.weather_details);
                this.user["access_token"] = res.data.data.access_token;
                this.user["customer_id"] = res.data.data.customer_id;
                sessionStorage.setItem("userData", JSON.stringify(this.user));
                sessionStorage.setItem("offerData", offerData);
                this.classNames["is-loading"] = false;
                this.$router.push("/claim-prize");
              }
            })
            .catch(err => {
              this.$router.push({
                name: "Error",
                params: { title: err.name, message: err.message }
              });
              Raven.captureException(err);
            });
        })
        .catch(err =>
          this.$router.push({
            name: "Error",
            params: {
              title: "Geolocation Blocked",
              message: err.message
            }
          })
        );
    }
  }
};
</script>

<style lang="scss">
</style>




// WEBPACK FOOTER //
// src/routes/WebViewRegister.vue